import { render, staticRenderFns } from "./VTab.vue?vue&type=template&id=5ba1bc4e&scoped=true&"
import script from "./VTab.vue?vue&type=script&lang=js&"
export * from "./VTab.vue?vue&type=script&lang=js&"
import style0 from "./VTab.vue?vue&type=style&index=0&id=5ba1bc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1bc4e",
  null
  
)

export default component.exports